import {Documents, EfeResponse, LegalRepresentativeServiceRequest, PersonalDataServiceRequest, RealOwnerServiceRequest, ValidateIneReq, ValidationsINEResponse} from 'commons/models';
import {DocumentServices, ValidationsService} from 'services';
import {blobToBase64} from './Functions';

type OrcValidations = {
    success: boolean;
    errors: Array<string>;
    response?: ValidationsINEResponse;
};

export async function validateOcrResponse(
    response: ValidationsINEResponse,
    generalData: PersonalDataServiceRequest | LegalRepresentativeServiceRequest | RealOwnerServiceRequest
): Promise<OrcValidations> {
    const currentYear = new Date().getFullYear();
    const ocrStatus: OrcValidations = {
        success: false,
        errors: [],
    };

    if (response.tipo !== 'INE' && response.tipo !== 'IFE') {
        ocrStatus.errors = ['Documento no v\u00E1lido para el tipo de identificaci\u00F3n.'];
        return ocrStatus;
    }
    if (Number(response.vigencia) < currentYear) {
        ocrStatus.errors = [
            'Identificaci\u00F3n no v\u00E1lida, su identificaci\u00F3n ya no es vigente.',
        ];
        return ocrStatus;
    }
    if (!response.ocr) {
        ocrStatus.errors = [
            'Identificaci\u00F3n no v\u00E1lida, favor de capturar correctamente el frente y reverso de tu INE/IFE.',
        ];
        return ocrStatus;
    }
    if (
        generalData.name !== response.nombres ||
        generalData.lastName !== response.primerApellido ||
        generalData.secondLastName !== response.segundoApellido
    ) {
        ocrStatus.errors = ['INE/IFE alterado o inv\u00E1lida, Favor de validar su INE/IFE.'];
        return ocrStatus;
    }
    if (response && generalData &&
        response.curp !== generalData.curp
    ) {
        if (generalData?.curp && response.curp?.length >= 13 && generalData?.curp?.length >=13) {
            if(generalData.curp.substring(0,12) !== response.curp.substring(0,12)) {
                ocrStatus.errors = ['INE/IFE alterado o inv\u00E1lida, Favor de validar su INE/IFE.'];
                return ocrStatus;
            }
        }
    }

    const payloadValidaIne = {} as ValidateIneReq;

    if (!response.ocr) {
        ocrStatus.errors = ['Fotograf\u00EDa desenfocada, favor de reintentar de nuevo.'];
        return ocrStatus;
    }

    if (['E', 'F', 'G', 'H'].includes(response.subTipo)) {
        if (!response.cic || !response.identificadorCiudadano) {
            ocrStatus.errors = ['Fotograf\u00EDa desenfocada, favor de reintentar de nuevo.'];
            return ocrStatus;
        }
        payloadValidaIne.cic = response.cic;
        payloadValidaIne.identificadorCiudadano = response.identificadorCiudadano;
    }

    if (response.subTipo === 'D') {
        if (!response.cic || !response.ocr) {
            ocrStatus.errors = ['Fotograf\u00EDa desenfocada, favor de reintentar de nuevo.'];
            return ocrStatus;
        }
        payloadValidaIne.cic = response.cic;
        payloadValidaIne.ocr = response.ocr;
    }

    if (response.subTipo === 'C') {
        if (!response.claveElector || !response.registro) {
            ocrStatus.errors = ['Fotograf\u00EDa desenfocada, favor de reintentar de nuevo.'];
            return ocrStatus;
        }
        payloadValidaIne.claveElector = response.claveElector;
        payloadValidaIne.numeroEmision = response.registro.split(' ')[1];
        payloadValidaIne.ocr = response.ocr;
        payloadValidaIne.type = 'C';
    }
    try {
        const evaluateIneResult = await ValidationsService.evaluateIneData(payloadValidaIne);
        if (evaluateIneResult.data?.estatus === 'ERROR') {
            ocrStatus.errors = [
                `INE/IFE Alterado o inv\u00E1lido. ${evaluateIneResult.data.mensaje}`,
            ];
            return ocrStatus;
        }
    } catch (error: any) {
        ocrStatus.errors = ['INE/IFE Alterado o inv\u00E1lido'];
        return ocrStatus;
    }
    ocrStatus.success = true;
    return ocrStatus;
}

export async function getIdentification(expedientNumber:number, kycIdNumber: number, documentKey: string):Promise<string> {
    try {
        const dniFrontResponse: EfeResponse<Documents> =
            await DocumentServices.getDocumentByKycId(
                documentKey,
                expedientNumber,
                kycIdNumber
            );
            if (
                dniFrontResponse &&
                dniFrontResponse.data &&
                dniFrontResponse.data.data
            ) {
                const x = await blobToBase64(dniFrontResponse.data.data);
                return x.toString();
            }
    } catch (error) {
        console.error();
    }
    return '';
}
